import { isFuture, parseISO } from 'date-fns';
import { AgentRatingSubmitDTO } from '../../types';

export const averageCriteriaRating = (
  criteriaRatings: AgentRatingSubmitDTO['criteriaRatings'] = []
) =>
  criteriaRatings.reduce((acc, { rating }) => acc + rating, 0) /
  (criteriaRatings.length || 1);

/** Agent appointments can be rated once the vessel has sailed. */
export const isAgentRatingOpen = (
  isAgent: boolean,
  sailingDate?: string | null
) => isAgent && !!sailingDate && !isFuture(parseISO(sailingDate));
